import { LEAD_SOURCES } from '../constants/leadConstants';
import { fixTextEncoding } from './sourceMapper';

export const leadsParser = (leads) => {
  const allLeads = [];
  leads?.map((leadData) => {
    const lead = leadData.dataValues || leadData;
    let data;
    try {
      data = typeof lead.data === 'string' ? JSON.parse(lead.data) : lead.data;
    } catch (error) {
      data = lead.data;
    }

    // Base lead object with all API fields preserved
    let leadObj = {
      // Core identification fields
      id: lead.id,
      siteId: lead.siteId,
      messageId: lead.messageId,
      company_id: lead.company_id,

      // Status and management fields
      status: lead.status,
      priority: lead.priority,
      isNew: lead.isNew,

      // Assignment fields
      assigned_to: lead.assigned_to,
      assigned_at: lead.assigned_at,
      assignee: lead.assignee,

      // Financial fields
      order_value: lead.order_value,
      quoted_value: lead.quoted_value,
      currency: lead.currency,
      estimated_close_date: lead.estimated_close_date,

      // Activity and tracking
      last_activity_at: lead.last_activity_at,
      activity_count: lead.activity_count,

      // UTM tracking fields
      utm_source: lead.utm_source || null,
      utm_medium: lead.utm_medium || null,
      utm_campaign: lead.utm_campaign || null,
      utm_content: lead.utm_content || null,
      utm_term: lead.utm_term || null,
      utm_platform: lead.utm_platform || null,

      // Contact information
      senders_email: lead.senders_email,
      sendersEmail: lead.senders_email, // Keep both for compatibility

      // Content and notes
      notes: lead.notes,
      tags: lead.tags,
      custom_fields: lead.custom_fields,

      // Metadata
      source: lead.source,
      createdAt: lead.createdAt,
      updatedAt: lead.updatedAt,
      updated_by: lead.updated_by,

      // Related data
      site: lead.site,
      company: lead.company,
      updater: lead.updater,

      // Legacy fields
      domain: lead.site?.domain || leadData.domain,
      // Support both new 'files' array and legacy 'leads_files'
      leadFiles: lead.files || lead.leads_files || [],

      // Raw data for fallback
      data: lead.data,
    };

    // Handle content based on source type
    if (lead.source === LEAD_SOURCES.CUSTOM) {
      leadObj = {
        ...leadObj,
        from: data?.from,
        content: data?.content || (typeof data === 'object' && data ?
          Object.entries(data).map(([key, value]) => `${key}: ${value}`).join('\n') :
          String(data || '')),
      };
    }

    if (lead.source === LEAD_SOURCES.NIMBATA || lead.source === LEAD_SOURCES.FORM) {
      leadObj = {
        ...leadObj,
        content: typeof data === 'object' && data ?
          Object.entries(data).map(([key, value]) => `${key}: ${value}`).join('\n') :
          String(data || ''),
      };
    }

    // Fallback content generation if no content exists
    if (!leadObj.content) {
      leadObj.content = typeof data === 'object' && data ?
        Object.entries(data).map(([key, value]) => `${key}: ${value}`).join('\n') :
        String(data || 'Inget innehåll tillgängligt');
    }

    if (leadObj.content) {
      leadObj.content = fixTextEncoding(leadObj.content);
    }
    if (leadObj.from) {
      leadObj.from = fixTextEncoding(leadObj.from);
    }

    return allLeads.push({ ...leadObj });
  });

  return allLeads;
};
